/* globals window document  */

import Vue from 'vue';

import { RestComponent } from '../../../mixins/rest-component';
import { TranslatedComponent } from '../../../mixins/translated-component';
import QdFilter from '../../filter/filter.js';
import QdSelectBox from '../../select-box/select-box.js';
import template from './page-category.vhtml';

export const PageCategory = Vue.component('page-category', {
	components: {
		QdFilter,
		QdSelectBox,
	},
	mixins: [RestComponent, TranslatedComponent],
	template: template,
	props: {
		postId: Number,
		siteData: {
			type: Object,
			default: () => { },
		},
	},
	data: () => ({
	}),
	computed: {
		sortedChildren() {
			let items = this.content.children;
			let sortedItems = this.sortItems(items);
			return sortedItems;
		},
		filteredChildren() {
			let filteredItems = this.sortedChildren;

			if (this.activeMonthFilters.length) {
				filteredItems = this.filteredByMonth(filteredItems);
			}

			if (this.activeLocationFilters.length) {
				filteredItems = this.filteredByLocation(filteredItems);
			}

			if (this.activePriceFilters.length) {
				filteredItems = this.filteredByPrice(filteredItems);
			}

			return filteredItems;
		},
		activeMonthFilters() {
			return this.content.filters.month.filter(el => el.selected);
		},
		activeLocationFilters() {
			return this.content.filters.location.filter(el => el.selected);
		},
		activePriceFilters() {
			return this.content.filters.price.filter(el => el.selected);
		},
	},
	watch: {
		language() {
			if (this.hasOwnProperty('content')) {
				document.title = this.content.metaTitle[this.language];
			}
		},
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		sortItems(children) {
			children.sort((a, b) => {
				if ( window.Intl ) {
					return new Intl.Collator(this.language).compare(a.i18n[this.language].title, b.i18n[this.language].title);
				} else {
					if (a.i18n[this.language].title < b.i18n[this.language].title) return -1;
					if (a.i18n[this.language].title > b.i18n[this.language].title) return 1;
					return 0;
				}
			});
			return children;
		},
		filteredByMonth(children) {
			return children.filter(el => this.filterByMonth(el.month));
		},
		filterByMonth(months) {
			let isIncl = false;
			this.activeMonthFilters.forEach(filter => {
				months.forEach(month => {
					if (!isIncl && filter.value === month) {
						isIncl = true;
					}
				});
			});
			return isIncl;
		},
		filteredByLocation(children) {
			return children.filter(el => this.filterByLocation(el.location));
		},
		filterByLocation(locations) {
			let isIncl = false;
			this.activeLocationFilters.forEach(filter => {
				locations.forEach(location => {
					if (!isIncl && filter.value === location) {
						isIncl = true;
					}
				});
			});
			return isIncl;
		},
		filteredByPrice(children) {
			return children.filter(el => this.filterByPrice(el.price));
		},
		filterByPrice(price) {
			let isIncl = false;
			this.activePriceFilters.forEach(filter => {
				if (filter.value === price) {
					isIncl = true;
				}
			});
			return isIncl;
		},
		setupChildren(children) {
			const setupedChildren = children.map( child => {
				if ( child.monthOrder.length ) {
					child.periods = this.createPeriods(child.monthOrder);
				}
				return child;
			});
			return setupedChildren;
		},
		ellipsisText( str, length ) {
			return str.length > length ? str.substr(str, length) + '...' : str;
		},
	},
});



// WEBPACK FOOTER //
// ./assets/_js/components/post-types/page-category/page-category.js